import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type { GetCategoryResponse } from '~/types/apis/v2/getCategory'
import type { GetOptionProductAllResponse } from '~/types/apis/v2/getOptionProductAll'
import type { GetProductDetailResponse } from '~/types/apis/v2/getProductDetail'
import type { GetProductListResponse } from '~/types/apis/v2/getProductList'
import type { GetProductOptionResponse } from '~/types/apis/v2/getProductOption'
import type { GetProductVariableResponse } from '~/types/apis/v2/getProductVariable'

export const productRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getProductDetail(
    url: string,
    options: FetchOptions = {}
  ): Promise<GetProductDetailResponse> {
    return fetch<GetProductDetailResponse>(`/v2/storefront/product/${url}`, {
      ...options,
      method: 'GET'
    })
  },
  async getProductList(
    query: {
      all?: boolean
      order_by?: string
      sort_by?: string
      page?: number
      per_page?: number
    },
    options: FetchOptions = {}
  ): Promise<GetProductListResponse> {
    return fetch<GetProductListResponse>(`/v2/storefront/product`, {
      ...options,
      method: 'GET',
      query
    })
  },
  async getProductOption(
    id: string,
    options: FetchOptions = {}
  ): Promise<GetProductOptionResponse> {
    return fetch<GetProductOptionResponse>(
      `/v2/storefront/product/${id}/product-option-group`,
      {
        ...options,
        method: 'GET'
      }
    )
  },
  async getProductDetailByOption(
    id: string,
    options: FetchOptions = {}
  ): Promise<GetProductDetailResponse> {
    return fetch<GetProductDetailResponse>(
      `/v2/storefront/product/${id}/product-option-variable`,
      {
        ...options,
        method: 'POST'
      }
    )
  },
  async getProductVariable(
    id: string,
    options: FetchOptions = {}
  ): Promise<GetProductVariableResponse> {
    return fetch<GetProductVariableResponse>(
      `/v2/storefront/product/${id}/product-variable`,
      {
        ...options,
        method: 'GET'
      }
    )
  },
  async getOptionProductAll(
    id: string,
    options: FetchOptions = {}
  ): Promise<GetOptionProductAllResponse> {
    return fetch<GetOptionProductAllResponse>(
      `/v2/storefront/product/${id}/product-option-check`,
      {
        ...options,
        method: 'GET'
      }
    )
  },
  async getCategoryAll(
    options: FetchOptions = {}
  ): Promise<GetCategoryResponse> {
    return fetch<GetCategoryResponse>(`/v2/storefront/category`, {
      ...options,
      method: 'GET'
    })
  },
  async updateWishList(
    options: FetchOptions & {
      body?: {
        product_slug: string
        artwork_slug?: string
      }
    } = {}
  ): Promise<unknown> {
    return fetch<unknown>('/v2/storefront/product/wishlist', {
      ...options,
      method: 'POST'
    })
  }
})
